// first stake - ante
// second stake - AA bonus

export const defaultSettingsReceive = [
  { name: 'stake', minStake: '0', maxStake: '1000000000000000000000000000000000000000000000000000000000000000000000000' },
  { name: 'stake', minStake: '0', maxStake: '1000000000000000000000000000000000000000000000000000000000000000000000000' },
  { name: 'sound' },
  { name: 'music' },
  { name: 'volume' },
]

export const defaultSettingsSend = [
  { name: 'stake', minStake: '0', maxStake: '' },
  { name: 'sound' },
  { name: 'music' },
  { name: 'volume' },
]

